module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/community administration-ba85318e0c663285e9fafda6bd42c436.png";